// vim: set ts=2 sts=2 sw=2 et:

import React from "react";
import { useLocation, useParams } from "react-router-dom";

import { isJudgePosition } from "../live/platformLiveProtocol";
import { parsePlatformRef } from "../operation/platformRef";
import JudgeContainer from "./JudgeContainer";

const JudgeRoute = () => {
  const params = useParams();
  const location = useLocation();
  const platformRef = parsePlatformRef(params.day, params.platformId);
  const judgePosition = isJudgePosition(params.judgePosition) ? params.judgePosition : null;

  return (
    <JudgeContainer
      platformRef={platformRef}
      judgePosition={judgePosition}
      locationPathname={location.pathname}
      locationSearch={location.search}
    />
  );
};

export default JudgeRoute;
